import ContextEntityType from "shared/enums/ContextEntityType";
import { Copies } from "shared/hooks/useCopies";
import { ApiFeaturedListResponse } from "shared/types/selection/ApiSelectionFeaturedList";

export abstract class BaseSystemGeneratedList {
  abstract getInitialValues(
    contextId: string,
    contextEntityType: ContextEntityType,
    data?: ApiFeaturedListResponse
  ): any;
  abstract getValidationSchema(copies: Copies): any;
}
